import { useState, useCallback } from 'react';
import { message } from 'antd';
import { c330Api, ReportFilter, ReportData } from '../../../services/c330Api';

export interface C330ReportState {
  loading: boolean;
  reportData: ReportData | null;
  queried: boolean;
  noData: boolean;
}

export interface C330ReportActions {
  runQuery: (filter: ReportFilter) => Promise<void>;
  reset: () => void;
}

export function useC330Report(): C330ReportState & C330ReportActions {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState<ReportData | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (filter: ReportFilter) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await c330Api.query(filter);
      if (resp.data && resp.data.details.length > 0) {
        setReportData(resp.data);
        setNoData(false);
      } else {
        setReportData(null);
        setNoData(true);
        message.info(resp.message || '查無符合條件的銷貨退回資料!');
      }
      setQueried(true);
    } catch (err) {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setReportData(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, reportData, queried, noData, runQuery, reset };
}
